





































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import RoundedBox from '@/shared/components/RoundedBox/RoundedBox.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';
import Accordion from '@/shared/components/Accordion/Accordion.vue';
import Button from '@/shared/components/Button/Button.vue';
import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';
import SelectableBox from '@/shared/components/SelectableBox/SelectableBox.vue';

import Plan from './Plan/Plan.vue';
import PlanMobile from './Plan/PlanMobile.vue';
import PlanLoading from './Plan/PlanLoading.vue';

import Coupon from './Coupon/Coupon.vue';

import Author from './Author/Author.vue';

import DiscountMessages from '../OfferCard/Discount/DiscountContainer.vue';

import InvoiceTotal from './Invoice/InvoiceTotal.vue';
import InvoiceDetailsLoading from './Invoice/InvoiceDetailsLoading.vue';
import InvoiceDetails from './Invoice/InvoiceDetails.vue';
import InvoiceTotalLoading from './Invoice/InvoiceTotalLoading.vue';

import OfferCardLoading from './OfferCardLoading.vue';

import Testimonials from '@/shared/components/Testimonials/Testimonials.vue';
import SecuredSection from '@/shared/components/SecuredSection/SecuredSection.vue';

import {
  ICheckoutCartOffer,
  ICheckoutCart,
  ICheckout,
  ICheckoutCartOfferTestimonial,
  ICheckoutCartOfferPrice
} from '@/interfaces/Checkout';
import { IPayment } from '@/interfaces/Payment';

import { ECheckoutStep, EIntervalTypes, EPaymentMethod } from '@/helpers/enums';
import { Invoice } from '@/classes/Checkout/Invoice';
import { intervalBuild } from '@/helpers/checkout';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Author,
    Plan,
    PlanMobile,
    PlanLoading,
    InvoiceTotal,
    InvoiceTotalLoading,
    InvoiceDetails,
    InvoiceDetailsLoading,
    Coupon,
    RoundedBox,
    Accordion,
    Button,
    LoadingBlock,
    OfferCardLoading,
    ScreenSizeVisibility,
    Testimonials,
    SecuredSection,
    SelectableBox,
    DiscountMessages,
  }
})
export default class OfferCard extends Vue {
  public $refs!: {
    scroll: any;
  };

  private offerChangedKey: number = 0;

  @AppModule.State(state => state.step.currentStep)
  private stepsCurrentStep: number;

  @CustomerModule.Getter('isLogged')
  private isLogged!: boolean;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;

  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: IPayment;

  @CheckoutModule.Getter('selectedOffer')
  private offer!: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private rootOffer!: ICheckoutCartOffer;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CheckoutModule.Getter('selectedOfferTestimonials')
  private offerTestimonials: ICheckoutCartOfferTestimonial[];

  @CheckoutModule.Getter
  private rootOfferRelated: any[];

  @CheckoutModule.Action
  private selectOffer!: (offerId: number)=> any;

  @CheckoutModule.Getter
  private rewardsPointsPaymentIsAvailable: boolean;

  @CheckoutModule.Getter
  private selectedOfferPrice!: ICheckoutCartOfferPrice;

  @CheckoutModule.State
  private creditCard: any;

  private changeOffer (offerId: number) {

    if(this.offer.id === offerId) return;

    this.selectOffer(offerId);

    this.offerChangedKey += 1;
  }

  private planInfo (offer: ICheckoutCartOffer) {
    let interval = intervalBuild(offer.interval_type as string, offer.interval_count as number, false, true, true);

    if (offer.interval_type !== EIntervalTypes.months) {
      interval = 'mês';
    }

    if (offer.interval_type === EIntervalTypes.lifelong) {
      return interval;
    }

    const installments = offer.invoice.paymentMethodInstallments;

    let sufix = installments && `${this.$n(installments.amount, 'currency')}/${interval}`;
    let prefix = 'apenas ';

    if (installments && installments.number <= 1 || !installments) {
      prefix = 'por ';
      sufix = interval;
    }

    return `${prefix}${sufix}`;
  }

  private get showTestimonials() {
    return process.env.VUE_APP_TESTIMONIALS_ENABLED === 'true';
  }

  private get purchaseSteps(): any {
    return ECheckoutStep;
  }

  private get cart(): ICheckoutCart {
    return this.checkout.cart;
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get offerTitle(): string {
    return (this.offer && this.offer.display_name) || '';
  }

  private get offerDescription() {
    return (this.offer && this.offer.short_description) || '';
  }

  private get offerCanUseCoupon(): boolean {
    return Boolean(this.offer.can_use_coupon && this.selectedOfferPrice && this.selectedOfferPrice.price);
  }

  private get HTMLDescription(): string {
    const { html_description = '', html_renewal_description = '' } = this.offer || {};

    if (this.isRenewal && html_renewal_description) {
      return html_renewal_description!;
    }

    return html_description!;
  }

  private get showRelnc (): boolean {
    const { relnc } = this.$route.query;
    const { breakpoint } = this.$vuetify;

    return relnc === '1' && breakpoint.smAndDown;
  }

  private get HTMLHeader(): any {
    const title = !this.isRenewal
      ? 'App.Checkout.Offer.htmlLabel'
      : 'App.Checkout.Offer.renew.htmlLabel';

    return this.$t(title);
  }

  get intervalType(): string {
    return (this.offer && this.offer.interval_type) || '';
  }

  private get ABOrderForm() {
    return this.$route.query.of === '1';
  }

  private get hideDescription() {
    return this.$route.query.hd === '1';
  }

  private get showPanel() {
    return (this.ABOrderForm && this.isMobile) || this.hideDescription ? 1 : 0;
  }

  private invoice(relatedOffer: any) {
    let invoice = {
      paymentMethod: EPaymentMethod.creditCard,
      paymentMethodInstallments: {
        number: 0,
        amount: 0,
      },
      paymentMethodAtSightAmount: 0,
      paymentMethodAtSightDiscountAmount: 0,
      paymentMethodAtSightDiscountPercentage: 0,
      originalAmount: 0,
      totalAmount: 0,
      creditAmount: 0,
      discountAmount: 0,
      discountPercentage: 0,
    };
    const paymentStructures = relatedOffer && this.paymentStructure(relatedOffer);
    const paymentMethod: any = this.paymentSelected.getPaymentMethod(this.selectedPaymentMethod);

    let condition = paymentStructures && paymentStructures.payment_conditions && paymentStructures.payment_conditions.find((el: any) => {
      return el.payment_method_code === this.selectedPaymentMethod;
    });

    invoice.creditAmount = paymentStructures && paymentStructures!.credit_amount ? paymentStructures!.credit_amount : 0;

    const installments = condition && condition.installments && condition.installments.length
      ? condition.installments
      : [{number: 0, amount: 0}, {number: 0, amount: 0}];
    const firstInstallment = installments[0];
    const lastInstallment = installments[installments.length - 1];

    if (paymentStructures && firstInstallment && lastInstallment) {
      invoice.paymentMethod = this.selectedPaymentMethod;
      invoice.paymentMethodInstallments = {
        number: lastInstallment.number,
        amount: lastInstallment && lastInstallment.amount
      };

      invoice.paymentMethodAtSightAmount = firstInstallment && parseFloat(String((firstInstallment.amount) ? firstInstallment.amount : 0));
      invoice.paymentMethodAtSightDiscountPercentage = (paymentMethod && paymentMethod.discount_amount) ? paymentMethod.discount_amount : 0;
      invoice.originalAmount = paymentStructures && paymentStructures.cart_initial_price;
      invoice.discountAmount = paymentStructures && paymentStructures.global_discount_amount;
      invoice.totalAmount = paymentStructures && paymentStructures.cart_subtotal_price;
      invoice.discountPercentage = paymentMethod && paymentMethod.discount_percentage;
    }

    return invoice;
  }

  private get selectedPaymentMethod() {
    return this.paymentSelected && this.paymentSelected.selectedPaymentMethod;
  }

  private paymentStructure(relatedOffer: any) {
    let additionalPaymentConditions: any = [];
    let paymentStructures: any = null;

    const offerPriceId = relatedOffer && relatedOffer.offer_price && relatedOffer.offer_price.length > 0 && relatedOffer.offer_price[0].id;

    if (relatedOffer && relatedOffer.payment_structure) {
      paymentStructures = this.generatingPaymentStructure(relatedOffer, offerPriceId);
    }

    return paymentStructures;
  }

  private get paymentSelected() {
    const rootOfferRelated = this.rootOfferRelated && this.rootOfferRelated.find((value: any) => value.id === this.offer.id);
    return rootOfferRelated && rootOfferRelated.payment;
  }

  private get title(): string|null|undefined {
    return this.offer.related_offer_title || this.offer.subtitle;
  }

  private get multiPaymentActived() {
    return this.creditCard && this.creditCard.filterActived;
  }

  private generatingPaymentStructure(offer: ICheckoutCartOffer, offerPriceId: any): any {
    let paymentStructureArr: any = {};
    let paymentConditions: any = [];
    let additionalPaymentConditions: any = [];

    if (offer && offer.payment_structure) {
      offer.payment_structure.forEach((payment_structure_value: any) => {
        if (!payment_structure_value.is_multi_payment_options && payment_structure_value.payment_conditions.length === 1) {
          paymentConditions.push({
            offer_payment_condition_id: payment_structure_value.offer_payment_condition_id,
            ...payment_structure_value.payment_conditions[0],
          });
        }

        if (payment_structure_value.is_multi_payment_options)
          additionalPaymentConditions.push({
            offer_payment_condition_id: payment_structure_value.offer_payment_condition_id,
            ...this.generateAdditionalPaymentConditions(payment_structure_value)
          });
      });

      const paymentStructureDefault = offer.payment_structure.find((paymentStructure: any) => paymentStructure.price_id === offerPriceId);

      paymentStructureArr = {
        ...paymentStructureDefault,
        payment_conditions: paymentConditions,
        additional_payment_conditions: additionalPaymentConditions
      };
    }

    return paymentStructureArr;
  }

  private generateAdditionalPaymentConditions(payment_structure: any): any {
    let additionalPaymentCondition: any = {};
    let paymentMethodCode = payment_structure.payment_conditions.reduce((a: any, b: any) => {
      return a.payment_method_code + '_' + b.payment_method_code;
    });

    if (payment_structure) {
      additionalPaymentCondition = {
        is_multi_payment_options: payment_structure.is_multi_payment_options,
        payment_method_code: paymentMethodCode,
        payment_conditions: payment_structure.payment_conditions,
      };
    }

    return additionalPaymentCondition;
  }
}
